import type { ConversationMessage } from "@/stores/conversation-store";

export function reconcileOptimisticUserMessage(
  state: { messages: ConversationMessage[] },
  message: ConversationMessage,
): { messages: ConversationMessage[] } | typeof state {
  const saved = { ...message, isOptimistic: false };
  const savedIndex = state.messages.findIndex(
    (candidate) => candidate.id === saved.id,
  );
  const optimisticIndex = saved.clientRequestId
    ? state.messages.findIndex(
        (candidate) =>
          candidate.isOptimistic &&
          candidate.clientRequestId === saved.clientRequestId,
      )
    : -1;
  if (savedIndex !== -1) {
    // Recovery can rebind the same durable user message to a new execution.
    return {
      messages: state.messages.flatMap((candidate, index) => {
        if (index === savedIndex) return [saved];
        return index === optimisticIndex ? [] : [candidate];
      }),
    };
  }
  if (optimisticIndex === -1) {
    return { messages: [...state.messages, saved] };
  }
  const messages = [...state.messages];
  messages[optimisticIndex] = saved;
  return { messages };
}
